export const SET_UNITS_LOADING = 'SET_UNITS_LOADING';
export const SET_UNITS = 'SET_UNITS';
export const SET_INVALIDATE = 'SET_INVALIDATE';

export default {
  /**
   * Save loading status.
   *
   * @param state - Neris state
   * @param {Object} data - Units loading value.
   */
  [SET_UNITS_LOADING]: (state, data) => {
    state.unitsLoading = data;
  },

  /**
   * Save units list.
   *
   * @param state - Neris state
   * @param {Object} data - Units list.
   */
  [SET_UNITS]: (state, data) => {
    state.units = data;
  },

  /**
   * Save Invalidate flag.
   *
   * @param state - Neris state
   * @param {Boolean} data - Invalidate Flag.
   */
  [SET_INVALIDATE]: (state, invalidate) => {
    state.invalidate = invalidate;
  },
};
